import { useEffect, useRef } from 'react';

// TODO: Move to @quick/utils. This one duplicates is duplicated in pwa
function useClickOutside<T extends Element = HTMLElement>(handler: () => void) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!ref.current) return;
    const onClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Element)) handler();
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [ref, ref.current, handler]);
  return ref;
}

export default useClickOutside;
